import * as Diagram from "../../../../components/diagram";

export const ElderlyHealthStatisticsReport112 = {
  label: "老人健康統計報表(112年)",
  key: "ElderlyHealthStatisticsReport112",
  path: "ElderlyHealth/ElderlyHealthStatisticsReport112",
  api: "TCS_V_ElderlyHealthCareVisitMonthlyReport",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthStatisticsReport112 {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isColSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
    {
      key: "VillageName",
      field: "VillageName",
      header: "",
    },
  ],
  columns: [
    {
      key: "inVillage",
      field: "inVillage_format",
      header: "65歲以上\n在籍人數",
    },
    {
      key: "controlCount",
      field: "controlCount_format",
      header: "去年已健康評估",
    },
    {
      key: "controlVisitCount",
      field: "controlVisitCount_format",
      header: "當年已健康評估",
    },
    {
      key: "inAgency",
      field: "inAgency_format",
      header: "入住機構",
    },
    {
      key: "dead",
      field: "dead_format",
      header: "死亡",
    },
    {
      key: "level",
      field: "level_format",
      header: "列管等級",
      // isControl: true,
      // isSum: true,
      child: [
        {
          key: "level1",
          field: "level1_format",
          header: "健康",
        },
        {
          key: "level2",
          field: "level2_format",
          header: "亞健康",
        },
        {
          key: "level3",
          field: "level3_format",
          header: "衰弱",
        },
        {
          key: "level4",
          field: "level4_format",
          header: "失能",
        },
      ],
    },
  ],
};
